import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigService } from './shared/services/app-config.service';
import { Title } from '@angular/platform-browser';
import { LanguageService } from './shared/services/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {

  /**
   * name of the module to run when integrated in other webpage
   *
   * @type {string}
   * @memberof AppComponent
   */
  singleModule: string;

  /**
   * set to true to run app as standalone web-page
   *
   * @type {boolean}
   * @memberof AppComponent
   */
  fullApp: boolean;

  constructor(
    private elementRef: ElementRef,
    private translate: TranslateService,
    private language: LanguageService,
    private titleService: Title,
    private renderer: Renderer2,
  ) {
    // can not use @Input on app-root
    this.singleModule = this.elementRef.nativeElement.getAttribute('singleModule');
  }

  // implement OnInit's `ngOnInit` method
  ngOnInit() {
    this.setupTranslation();

    this.translate.get('APPTITLE').subscribe((title: string) => {
      this.titleService.setTitle(title);
    });

    this.fullApp = this.singleModule === null;
  }

  /**
   * load language and load translations
   *
   * @private
   * @memberof AppComponent
   */
  private setupTranslation(): void {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang(AppConfigService.settings.availableLanguages[0]);

    // get lang from localStorage
    let language = this.language.getLanguage();

    // get lang from user agent
    if (language === null) {
      language = LanguageService.GetBestClientLanguage(AppConfigService.settings.availableLanguages);

      // use primary language
      if (language === null) {
        language = AppConfigService.settings.availableLanguages[0];
      }
    }

    this.language.setLanguage(language, this.renderer);
  }
}
